<div class="isp-page__copyright">
  <ispui-link
    color="additional"
    type="default-hover"
    target="_blank"
    rel="nofollow"
    [href]="href"
  >
    <span [innerHTML]="text"></span>
  </ispui-link>
</div>
